import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
export var uniqueAndSorted = function(arr) {
    return _to_consumable_array(new Set(arr)).sort();
};
